import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { styled } from '@mui/material';
import TextArea from '../TextArea/TextArea.js';
import Button from '../Button/Button.js';
import '../Button/SplitButton.js';

const Container = styled('div') `
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  grid-row-gap: 4px;
  & > .styled-scrollbar {
    max-width: 100%;
  }
`;
const _Button = styled(Button) `
  padding: 2px 4px;
  font-size: 10px;
  height: 20px;
`;
/**
 * An optional text area input, which can be shown or hidden by clicking a button
 */
const AddRemoveTextArea = (_a) => {
    var { addButtonLabel, removeButtonLabel } = _a, textAreaProps = __rest(_a, ["addButtonLabel", "removeButtonLabel"]);
    const [isOpen, setIsOpen] = useState(false);
    const toggleTextArea = () => {
        var _a;
        if (isOpen) {
            setIsOpen(false);
            (_a = textAreaProps.onChange) === null || _a === void 0 ? void 0 : _a.call(textAreaProps, { target: {} });
        }
        else {
            setIsOpen(true);
        }
    };
    return (jsxs(Container, { children: [isOpen && jsx(TextArea, Object.assign({ withBorder: true }, textAreaProps)), jsx(_Button, Object.assign({ onClick: toggleTextArea, variant: "text" }, { children: isOpen ? removeButtonLabel : addButtonLabel }))] }));
};

export { AddRemoveTextArea as default };
//# sourceMappingURL=AddRemoveTextArea.js.map
